import React from 'react';
export function MachineModelsSection() {
  return <div className="grid lg:grid-cols-2 gap-12 mb-20" data-id="element-1122">
      {/* GENESI E2 */}
      <div className="bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden flex flex-col" data-id="element-1123">
        <div className="p-8 border-b border-gray-100 bg-gray-50 flex-grow" data-id="element-1124">
          <h3 className="text-3xl font-bold text-[#9B0137] uppercase tracking-tight mb-6 text-center" data-id="element-1125">
            GENESI E2
          </h3>
          <img src="https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/Breton/Genesi%20E2.jpg800x800.jpg" alt="Genesi E2" className="block max-w-full h-auto mx-auto mb-8" data-id="element-1126" />
        </div>
        <div className="overflow-x-auto" data-id="element-1127">
          <table className="w-full text-sm text-left" data-id="element-1128">
            <thead className="bg-gray-100 text-navy border-b border-gray-200" data-id="element-1129">
              <tr data-id="element-1130">
                <th className="px-4 py-3 font-semibold" data-id="element-1131">Spec</th>
                <th className="px-4 py-3 font-bold text-[#9B0137]" data-id="element-1132">
                  GENESI E2 k40
                </th>
                <th className="px-4 py-3 font-bold text-[#9B0137]" data-id="element-1133">
                  GENESI E2 k50
                </th>
                <th className="px-4 py-3 font-bold text-[#9B0137]" data-id="element-1134">
                  GENESI E2 + M
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100" data-id="element-1135">
              <tr className="bg-white" data-id="element-1136">
                <td className="px-4 py-3 font-semibold text-navy" data-id="element-1137">Version</td>
                <td className="px-4 py-3 text-gray-600" data-id="element-1138">pure additive</td>
                <td className="px-4 py-3 text-gray-600" data-id="element-1139">pure additive</td>
                <td className="px-4 py-3 text-gray-600" data-id="element-1140">additive + milling</td>
              </tr>
              <tr className="bg-gray-50" data-id="element-1141">
                <td className="px-4 py-3 font-semibold text-navy" data-id="element-1142">
                  X-Axis Stroke
                </td>
                <td className="px-4 py-3 text-gray-600" data-id="element-1143">157.5 in.</td>
                <td className="px-4 py-3 text-gray-600" data-id="element-1144">236 in.</td>
                <td className="px-4 py-3 text-gray-600" data-id="element-1145">185 in.</td>
              </tr>
              <tr className="bg-white" data-id="element-1146">
                <td className="px-4 py-3 font-semibold text-navy" data-id="element-1147">
                  Y-Axis Stroke
                </td>
                <td className="px-4 py-3 text-gray-600" data-id="element-1148">74.8 in.</td>
                <td className="px-4 py-3 text-gray-600" data-id="element-1149">74.8 in.</td>
                <td className="px-4 py-3 text-gray-600" data-id="element-1150">74.8 in.</td>
              </tr>
              <tr className="bg-gray-50" data-id="element-1151">
                <td className="px-4 py-3 font-semibold text-navy" data-id="element-1152">
                  Z-Axis Stroke
                </td>
                <td className="px-4 py-3 text-gray-600" data-id="element-1153">51.2 in.</td>
                <td className="px-4 py-3 text-gray-600" data-id="element-1154">51.2 in.</td>
                <td className="px-4 py-3 text-gray-600" data-id="element-1155">51.2 in.</td>
              </tr>
              <tr className="bg-white" data-id="element-1156">
                <td className="px-4 py-3 font-semibold text-navy" data-id="element-1157">
                  Extrusion Capacity (max.)
                </td>
                <td className="px-4 py-3 text-gray-600" data-id="element-1158">154 lbs.</td>
                <td className="px-4 py-3 text-gray-600" data-id="element-1159">154 lbs.</td>
                <td className="px-4 py-3 text-gray-600" data-id="element-1160">154 lbs.</td>
              </tr>
              <tr className="bg-gray-50" data-id="element-1161">
                <td className="px-4 py-3 font-semibold text-navy" data-id="element-1162">
                  Milling Spindle
                </td>
                <td className="px-4 py-3 text-gray-400" data-id="element-1163">—</td>
                <td className="px-4 py-3 text-gray-400" data-id="element-1164">—</td>
                <td className="px-4 py-3 text-gray-600" data-id="element-1165">18/24,000 rpm</td>
              </tr>
              <tr className="bg-white" data-id="element-1166">
                <td className="px-4 py-3 font-semibold text-navy" data-id="element-1167">
                  Milling Tool Taper
                </td>
                <td className="px-4 py-3 text-gray-400" data-id="element-1168">—</td>
                <td className="px-4 py-3 text-gray-400" data-id="element-1169">—</td>
                <td className="px-4 py-3 text-gray-600" data-id="element-1170">HSK-A63</td>
              </tr>
              <tr className="bg-gray-50" data-id="element-1171">
                <td className="px-4 py-3 font-semibold text-navy" data-id="element-1172">Length</td>
                <td className="px-4 py-3 text-gray-600" data-id="element-1173">126 in.</td>
                <td className="px-4 py-3 text-gray-600" data-id="element-1174">126 in.</td>
                <td className="px-4 py-3 text-gray-600" data-id="element-1175">126 in.</td>
              </tr>
              <tr className="bg-white" data-id="element-1176">
                <td className="px-4 py-3 font-semibold text-navy" data-id="element-1177">Width</td>
                <td className="px-4 py-3 text-gray-600" data-id="element-1178">279 in.</td>
                <td className="px-4 py-3 text-gray-600" data-id="element-1179">396.45 in.</td>
                <td className="px-4 py-3 text-gray-600" data-id="element-1180">396.45 in.</td>
              </tr>
              <tr className="bg-gray-50" data-id="element-1181">
                <td className="px-4 py-3 font-semibold text-navy" data-id="element-1182">Height</td>
                <td className="px-4 py-3 text-gray-600" data-id="element-1183">223 in.</td>
                <td className="px-4 py-3 text-gray-600" data-id="element-1184">223 in.</td>
                <td className="px-4 py-3 text-gray-600" data-id="element-1185">223 in.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* GENESI E3 */}
      <div className="bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden flex flex-col" data-id="element-1186">
        <div className="p-8 border-b border-gray-100 bg-gray-50 flex-grow" data-id="element-1187">
          <h3 className="text-3xl font-bold text-[#9B0137] uppercase tracking-tight mb-6 text-center" data-id="element-1188">
            GENESI E3
          </h3>
          <img src="https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/Breton/Genesi%20E3.jpg800x800.jpg" alt="Genesi E3" className="block max-w-full h-auto mx-auto mb-8" data-id="element-1189" />
        </div>
        <div className="overflow-x-auto" data-id="element-1190">
          <table className="w-full text-sm text-left" data-id="element-1191">
            <thead className="bg-gray-100 text-navy border-b border-gray-200" data-id="element-1192">
              <tr data-id="element-1193">
                <th className="px-4 py-3 font-semibold" data-id="element-1194">Spec</th>
                <th className="px-4 py-3 font-bold text-[#9B0137]" data-id="element-1195">
                  GENESI E3
                </th>
                <th className="px-4 py-3 font-bold text-[#9B0137]" data-id="element-1196">
                  GENESI E3 + M
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100" data-id="element-1197">
              <tr className="bg-white" data-id="element-1198">
                <td className="px-4 py-3 font-semibold text-navy" data-id="element-1199">Version</td>
                <td className="px-4 py-3 text-gray-600" data-id="element-1200">pure additive</td>
                <td className="px-4 py-3 text-gray-600" data-id="element-1201">additive + milling</td>
              </tr>
              <tr className="bg-gray-50" data-id="element-1202">
                <td className="px-4 py-3 font-semibold text-navy" data-id="element-1203">
                  X-Axis Stroke
                </td>
                <td className="px-4 py-3 text-gray-600" data-id="element-1204">157.5 - 1181 in.</td>
                <td className="px-4 py-3 text-gray-600" data-id="element-1205">157.5 - 1181 in.</td>
              </tr>
              <tr className="bg-white" data-id="element-1206">
                <td className="px-4 py-3 font-semibold text-navy" data-id="element-1207">
                  Y-Axis Stroke
                </td>
                <td className="px-4 py-3 text-gray-600" data-id="element-1208">118 - 196.85 in.</td>
                <td className="px-4 py-3 text-gray-600" data-id="element-1209">118 - 196.85 in.</td>
              </tr>
              <tr className="bg-gray-50" data-id="element-1210">
                <td className="px-4 py-3 font-semibold text-navy" data-id="element-1211">
                  Z-Axis Stroke
                </td>
                <td className="px-4 py-3 text-gray-600" data-id="element-1212">78.75 - 98.42 in.</td>
                <td className="px-4 py-3 text-gray-600" data-id="element-1213">78.75 - 98.42 in.</td>
              </tr>
              <tr className="bg-white" data-id="element-1214">
                <td className="px-4 py-3 font-semibold text-navy" data-id="element-1215">
                  Extrusion Capacity (max.)
                </td>
                <td className="px-4 py-3 text-gray-600" data-id="element-1216">440 lbs.</td>
                <td className="px-4 py-3 text-gray-600" data-id="element-1217">440 lbs.</td>
              </tr>
              <tr className="bg-gray-50" data-id="element-1218">
                <td className="px-4 py-3 font-semibold text-navy" data-id="element-1219">
                  Milling Spindle
                </td>
                <td className="px-4 py-3 text-gray-400" data-id="element-1220">—</td>
                <td className="px-4 py-3 text-gray-600" data-id="element-1221">62/24,000 rpm</td>
              </tr>
              <tr className="bg-white" data-id="element-1222">
                <td className="px-4 py-3 font-semibold text-navy" data-id="element-1223">
                  Milling Tool Taper
                </td>
                <td className="px-4 py-3 text-gray-400" data-id="element-1224">—</td>
                <td className="px-4 py-3 text-gray-600" data-id="element-1225">HSK-A63</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}